import * as DialogPrimitive from "@radix-ui/react-dialog";
import type { ReactNode } from "react";

import { usePortalContainer } from "../../lib/portal-container";
import { useDialogContext } from "./DialogContext";

export const DialogPortal = ({ children }: { children: ReactNode }) => {
  const { placement } = useDialogContext();
  const container = usePortalContainer();

  if (placement === "contained") return children;

  return (
    <DialogPrimitive.Portal data-slot="dialog-portal" container={container ?? undefined}>
      {children}
    </DialogPrimitive.Portal>
  );
};
